export default "__VITE_ASSET__CnVZz60k__"